import { FC } from "react";

import Container from "@/components/base/container";
import { CustomerSuccessStoryI } from "@/interfaces/strapi/collection-types";
import { CustomerSuccessStoryHeader } from "@/modules/customer-success/story/story-header";
import { CompanyCard } from "@/modules/customer-success/story/company-card";
import { MoreSalesQualifiedMeetingsCTA } from "@/components/base/sections/call-to-action";
import { CustomerSuccessStoryBody } from "@/modules/customer-success/story/story-body";
import { OtherCustomerSuccessStoriesSection } from "@/modules/customer-success/other-customer-success-stories-section";
import { CustomerSuccessRequestDemo } from "@/modules/customer-success/story/request-demo";
import { BackgroundShape } from "shared/ui/background-shape";
import { BACKGROUND_SHAPES } from "shared/ui/background-shape/constants";

interface CustomerSuccessStoryModulePropsI {
  story?: CustomerSuccessStoryI;
  otherStories?: CustomerSuccessStoryI[];
}

export const CustomerSuccessStoryModule: FC<
  CustomerSuccessStoryModulePropsI
> = ({ story, otherStories }) => (
  <>
    <article>
      <Container className="relative flex flex-col gap-14 lg:flex-row xl:gap-[112px]">
        <CustomerSuccessStoryHeader data={story} />

        {story?.company && (
          <div className="flex flex-col">
            <CompanyCard
              className="hidden lg:block"
              company={story?.company.data.attributes}
            />
          </div>
        )}

        <BackgroundShape
          className="right-[60px] hidden w-fit blur-[70px] lg:block"
          imageClassName="w-[600px] "
          loadedImageClassName="blur-[65px]"
          shape={BACKGROUND_SHAPES.FIGURE_1}
        />
      </Container>

      <Container className="top-0 hidden justify-end lg:sticky lg:flex">
        <CustomerSuccessRequestDemo />
      </Container>

      <Container>
        <CustomerSuccessStoryBody
          className="relative lg:-mt-[320px] lg:max-w-[calc(100%_-_450px)] xl:-mt-[220px] 2xl:-mt-[280px]"
          content={story?.content}
        />
      </Container>
    </article>

    <article>
      <OtherCustomerSuccessStoriesSection
        className="mt-[139px] lg:mt-[157px] xl:mt-[142px]"
        stories={otherStories}
      />

      <MoreSalesQualifiedMeetingsCTA className="mt-[200px]" />
    </article>
  </>
);
